import React, { useState, useEffect } from "react";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function AdvancedSearch() {
  const [open, setOpen] = useState(true);

  // Sidebar auto collapse
  useEffect(() => {
    const handleResize = () => {
      setOpen(window.innerWidth >= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    ageFrom: "",
    ageTo: "",
    caste: "",
    star: "",
    sex: "",
    fromDate: "",
    toDate: ""
  });

  const [data, setData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSearch = async () => {
    const params = new URLSearchParams(form).toString();
    const url = `https://matrimony.cubixsystems.com/api/advanced_search.php?${params}`;
    setLoading(true);
    try {
      const res = await fetch(url);
      const result = await res.json();
      setData(result.records || []);
      setShowTable(true);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const formatDate = (d) => {
    const date = new Date(d);
    return date.toLocaleDateString("en-GB").replace(/\//g, "-");
  };

  const exportToExcel = () => {
    const exportData = data.map((row, i) => ({
      "Sl No": i + 1,
      RegNo: row.regNo,
      Name: row.name,
      Caste: row.caste,
      Age: row.age,
      Height:row.height,
      Star: row.star,
      Dhosham: row.dhosham,
      Qualification: row.qualification,
      Occupation: row.job,
      Native: row.native,
      Phone: row.phone
      //Date: formatDate(row.date),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Search Results");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Report.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF("landscape", "mm", "a4");

    const tableColumn = [
      "Sl No",
      "Reg No",
      "Name",
      "Caste",
      "Age",
      "Height",
      "Star",
      "Dhosham",
      "Qualification",
      "Occupation",
      "Native",
      "Phone"
     
    ];

    const tableRows = data.map((row, i) => [
      i + 1,
      row.regNo,
      row.name,
      row.caste,
      row.age,
      row.height,
      row.star,
      row.dhosham,
      row.qualification,
      row.job,
      row.native,
      row.phone,
      row.phone,
      // formatDate(row.date)
    ]);

    doc.text("", 14, 10);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20
    });

    doc.save("Report.pdf");
  };

  return (
    <div className="container-fluid p-0">
      <div className="d-flex" style={{ height: "100vh" }}>
        {/* LEFT SIDEBAR */}
        <div
          className="border-end leftcolor"
          style={{
            width: open ? "350px" : "0",
            overflow: "hidden",
            transition: "0.3s ease"
          }}
        >
          {open && (
            <div className="p-3">
              <AdminLeft />
            </div>
          )}
        </div>

        {/* RIGHT CONTENT */}
        <div
          className="p-4"
          style={{
            width: open ? "calc(100% - 350px)" : "100%",
            transition: "0.3s ease",
            paddingLeft: "30px"
          }}
        >
          <TopBanner />
          <div className="area mt-4" >
            <h2></h2>

            {/* Inputs */}
            <div className="mb-2">
              <input
                className="form-control- mb-2"
                name="name"
                placeholder="Name"
                onChange={handleChange}
              />
              <input
                className="form-control- mb-2"
                name="phone"
                placeholder="Phone"
                onChange={handleChange}
              />
              <input
                className="form-control- mb-2"
                name="ageFrom"
                placeholder="Age From"
                type="number"
                onChange={handleChange}
              />
              <input
                className="form-control- mb-2"
                name="ageTo"
                placeholder="Age To"
                type="number"
                onChange={handleChange}
              />
              <input
                className="form-control- mb-2"
                name="caste"
                placeholder="Caste"
                onChange={handleChange}
              />

              {/* Star Dropdown */}
              <select
                className="form-control- mb-2"
                name="star"
                onChange={handleChange}
              >
                <option value="">Select Star</option>
                <option>Aswathy</option>
                <option>Bharani</option>
                <option>Karthika</option>
                <option>Rohini</option>
                <option>Makayiram</option>
                <option>Thiruvathira</option>
                <option>Punartham</option>
                <option>Pooyam</option>

                <option>Aayilyam</option>
                <option>Makham</option>
                <option>Pooram</option>
                <option>Uthram</option>
                <option>Atham</option>
                <option>Chihira</option>
                <option>Chothi</option>
                <option>Visaakam</option>
                <option>Anizham</option>
                <option>Thrikketta</option>
                <option>Moolam</option>
                <option>Pooraadam</option>
                <option>Uthraadam</option>
                <option>Thiruvonam</option>
                <option>Avittam</option>
                <option>Chathayam</option>
                <option>Pooruruttathi</option>
                <option>Uthrattathi</option>
                <option>Revathi</option>

             </select>

              {/* Sex */}
              <select
                className="form-control- mb-2"
                name="sex"
                onChange={handleChange}
              >
                <option value="">Sex</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>

              {/* Date */}
              <input
                className="form-control- mb-2"
                type="date"
                name="fromDate"
                onChange={handleChange}
              />
              <input
                className="form-control- mb-2"
                type="date"
                name="toDate"
                onChange={handleChange}
              />
              <br />
              <button
                style={{background:'#004962ff',cursor:'pointer'}}
                className="btn btn-primary mb-2"
                onClick={handleSearch}
              >
                Search
              </button>

              <button
                className="btn  mb-2"
                onClick={exportToExcel}
                style={{ marginLeft: '10px',background:'white',border:'1px solid green',color:'black',cursor:'pointer' }}
              >
                Export to Excel
              </button>
              <button
                className="btn mb-2"
                onClick={exportToPDF}
                style={{ marginLeft: '10px',background:'white',border:'1px solid green', color:'black',cursor:'pointer'}}
              >
                Export to PDF
              </button>

              {loading && <p>Loading...</p>}
            </div>

            {/* TABLE (only after search) */}
            <div style={{ height: '70vh',overflow:'auto' }}>
              {showTable && (
                <table
                  border="1"
                  className="table table-striped mt-3"
                >
                  <thead>
                    <tr>
                      <th>Sl No</th>
                      <th>Name</th>
                      <th>Age</th>
                      <th>Caste</th>
                      <th>Star</th>
                      <th>Sex</th>
                      <th>Date</th>
                      <th>Phone</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? (
                      data.map((row, i) => (
                        <tr key={row.id}>
                          <td>{i + 1}</td>
                          <td>{row.name}</td>
                          <td>{row.age}</td>
                          <td>{row.caste}</td>
                          <td>{row.star}</td>
                          <td>{row.sex}</td>
                          <td>{formatDate(row.date)}</td>
                          <td>{row.phone}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8">No results found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}